import {
  createEconnectorClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

import { CreateNetworkProfile, NetworkProfile } from './model';

const client = createEconnectorClient('/api/network-profiles');

export const networkProfilePermissions = {
  SEARCH: 'econnector.search-network-profiles',
  GET: 'econnector.get-network-profile',
  CREATE: 'econnector.create-network-profile',
  UPDATE: 'econnector.update-network-profile',
  DELETE: 'econnector.delete-network-profile'
};

export const searchNetworkProfiles: SearchOperation<NetworkProfile> = searchRequestFactory<NetworkProfile>(client, {
  permissionId: networkProfilePermissions.SEARCH
});
export const getNetworkProfile: FindOperation<NetworkProfile, string> = getRequestFactory<NetworkProfile, string>(client, {
  permissionId: networkProfilePermissions.GET
});
export const createNetworkProfile: SaveOperation<CreateNetworkProfile> = postRequestFactory<CreateNetworkProfile, NetworkProfile>(client, {
  pattern: '',
  permissionId: networkProfilePermissions.CREATE
});
export const updateNetworkProfile: SaveOperation<NetworkProfile> = putRequestFactory<NetworkProfile, NetworkProfile>(client, {
  permissionId: networkProfilePermissions.UPDATE
});
export const deleteNetworkProfile: DeleteOperation<void, string> = deleteRequestFactory<void, string>(client, {
  permissionId: networkProfilePermissions.DELETE
});
